export const formatBold = (str) => {
  try {
    if (!str) {
      return "";
    }
    const indexs = findAllIndexsOfString(str, "*");
    if (indexs?.length > 0 && indexs?.length === 2) {
      return (
        <p>
          <h3>{str.substring(indexs[0] + 1, indexs[1])}</h3>
          {str.substring(indexs[1] + 1, str.length)}
        </p>
      );
    }

    return str;
  } catch (err) {
    return str;
  }
};

const findAllIndexsOfString = (str, charSearch) => {
  var indexs = [],
    i = -1;
  while ((i = str.indexOf(charSearch, i + 1)) >= 0) indexs.push(i);
  return indexs;
};
